export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref12066.7c323a9b.jpg";